<template>
<div class="store-card-box">
  <div class="store-card">
    <ClientOnly>
      <img v-lazy="$cvWebpFn(store?.storeIcon || '')" alt="" class="store-icon">

      <template #fallback>
        <img :src="useImg1pxBase64().value" lazy="loading" alt="" class="store-icon">
      </template>
    </ClientOnly>

    <div class="store-info">
      <p class="store-title">{{ store?.name }}</p>
      <div class="store-info-mark">
        <!-- authType: 1: 官方店铺，2: 品牌授权店 -->
        <img v-if="store?.authType === 1" class="store-tag" :src="$cvWebpFn(OFFICIAL_STORE_BADGE_URL)" alt="Brand Official" />
        <img v-else-if="store?.authType === 2" class="store-tag" :src="$cvWebpFn(AUTHORIZED_STORE_BADGE_URL)" alt="Brand Authorized" />
        <img v-if="store?.tags?.includes('store_preferred')" class="store-tag" :src="$cvWebpFn(PREFERRED_STORE_BADGE_URL)" alt="Preferred Store" />
      </div>
    </div>
 
    <div class="store-info-list">
      <div class="info-item">
        <div class="info-desc">Score</div>
        <div class="info-val">{{ store?.starRating || '5.0' }}</div>
      </div>
      <span class="line"></span>
      <div class="info-item">
        <div class="info-desc">All Products</div>
        <div class="info-val">{{ store?.products }}</div>
      </div>

      <div class="opt-bar">
        <!-- <a :href="`/store/${store?.id}`" target="_blank"> -->
        <a :href="`/store/${store?.storeAlias || store?.id}?first_page=productDetail`" target="_blank">
          <div class="opt-btn">
            <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/store-icon@2x.png', { w: 120 })" alt="">&nbsp;Visit Store
          </div>
        </a>
        <div class="opt-btn" @click="handleToChatClick">
          <img :src="$cvWebpFn('https://img.kilimall.com/c/h5/imgs/chat-icon@2x.png', { w: 120 })" alt="">&nbsp;Chat Seller
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script setup lang="ts">
const OFFICIAL_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_official_store.png'
const AUTHORIZED_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_authorized_store.png'
const PREFERRED_STORE_BADGE_URL = 'https://image.kilimall.com/c/h5/ic_preferred_storex.png'

defineProps<{ store?: Store.IStore }>()
const emits = defineEmits<{(event: 'to:chat'): void}>()

const router = useRouter()
const route = useRoute()

const handleToChatClick = () => {
  if(!useUserInfo().value?.accessToken) {
    router.push(`/login?redirect=${encodeURI(route.fullPath)}`)
  } else {
    emits('to:chat')
  }
}
</script>

<style lang="scss" scoped>
.store-card-box{
  padding: 40px 30px;
}
.store-card{
  display: flex;
  height: 100px;
  @include center();
}
.store-icon{
  width: 100px;
  min-width: 100px;
  height: 100px;
  object-fit: contain;
}
.store-info{
  padding: 10px;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .store-title{
    font-weight: 600;
    font-size: 34px;
    @include ellipsisMultiline(3)
  }
  .product-total{
    color: #999;
    font-size: 24px;
  }
}
.store-info-list{
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  padding: 20px 0;
  .line{
    display: inline-block;
    height: 60px;
    width: 1px;
    background: #cacaca;
  }
  .info-item{
    flex: 1;
    
    text-align: center;
    padding: 0 20px;
    min-width: 300px;
    // &:first-child{
    //   border-right: 1px solid #cacaca;
    // }
    .info-val{
      color: var(--pc-default-color);
      font-size: 38px;
      margin-top: 10px;
    }
    .info-desc{
      color: #666;
      font-size: 28px;
    }
  }
}
.opt-bar{
  display: flex;
  @include center();
  height: 100%;
  margin-left: 60px;
}
.favorite-tool-bar{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-top: 1px solid #efefef;
  margin-top: 20px;
}
.opt-btn{
  cursor: pointer;
  width: 268px;
  height: 68px;
  border-radius: 8px;
  border: 1px solid #CCCCCC;
  color: #333333;
  @include center();
  font-size: 30px;
  margin: 0 20px;
  img{
    height: 45px;
  }
}
.store-info-mark{
  display: flex;
  gap: 10px;
}
.store-tag {
  display: block;
  width: auto;
  height: 32px;
  margin-top: 10px;
}
</style>
